import { connect } from "react-redux";
import MilesEarned from "./MilesEarned";
import { calculatePreBookTotal } from "app/pages/Booking/bookingSelectors";
import { getDisplayMiles, getLoyalty } from "app/reducers/brandSelector";
import { getMilesPerCurrencyConfig, getMilesRatio } from "app/reducers/milesSelector";

export const findMilesPageSlug = (pages, loyalty) => {
	if (!Array.isArray(pages) || !loyalty) {
		return null;
	}

	const normalizedLoyalty = loyalty.toLowerCase().replace(/[^a-z0-9]/g, "");
	const page = pages.find(p => {
		if (!p?.slug) {
			return false;
		}
		const normalizedSlug = p.slug.toLowerCase().replace(/[^a-z0-9]/g, "");
		return normalizedSlug.startsWith(normalizedLoyalty);
	});

	return page?.slug || null;
};

const mapStateToProps = (state, ownProps) => {
	// Calcul du prix par personne si non fourni
	let price = ownProps.price;
	if (price === undefined) {
		const total = calculatePreBookTotal(state);
		const passengersCount = state.booking.adults + state.booking.children;
		price = passengersCount > 0 ? Math.floor(total / passengersCount) : 0;
	}

	const loyalty = getLoyalty(state);
	const milesPageSlug = findMilesPageSlug(state.pages, loyalty);
	const milesConfig = getMilesPerCurrencyConfig(state);

	return {
		displayMiles: getDisplayMiles(state),
		loyalty,
		milesRatio: getMilesRatio(state),
		currencyAmount: milesConfig?.currencyAmount,
		milesAmount: milesConfig?.milesAmount,
		currency: state?.currency,
		price: price,
		prefixLabel: ownProps.prefixLabel,
		prefixMessageId: ownProps.prefixMessageId,
		suffixLabel: ownProps.suffixLabel,
		moreDetailsLink: milesPageSlug ? `/page/${milesPageSlug}` : null,
	};
};

export default connect(mapStateToProps)(MilesEarned);
